import React from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { useRouter } from 'expo-router'

import { DS } from '@/design-system'

type ScreenHeaderProps = {
  title: string
  /** Defaults to router.back() */
  onBack?: () => void
}

/**
 * Standard screen header: back arrow on the left, centered maroon title,
 * balancing spacer on the right. Used by create-game and create-tournament.
 */
export function ScreenHeader({ title, onBack }: ScreenHeaderProps) {
  const router = useRouter()
  const handleBack = onBack ?? (() => router.back())

  return (
    <View style={styles.header}>
      <TouchableOpacity onPress={handleBack} style={styles.backButton} hitSlop={12}>
        <DS.Icon name="Arrow---left" width={24} height={24} color={DS.palette['Global/Black']} />
      </TouchableOpacity>
      <DS.Text variant="Heading 3/Medium" style={styles.title}>
        {title}
      </DS.Text>
      <View style={styles.headerSpacer} />
    </View>
  )
}

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 16
  },
  backButton: {
    width: 40
  },
  title: {
    flex: 1,
    textAlign: 'center',
    color: DS.palette['Brand/Maroon']
  },
  headerSpacer: {
    width: 40
  }
})
